import type { AIGuideCategory } from "./AIGuide.types";

// Placeholder text only — shown via the textarea's `placeholder` prop when a
// category has no real content yet, purely so it's visible what this is for.
// Never sent to the backend as real content.
export const PLACEHOLDER_CONTENT: Record<AIGuideCategory, string> = {
  news_updates:
    "e.g. Fall semester registration opens Monday at 9 AM — log in to the student portal to select electives before seats fill up. " +
    "The Central Library will stay open 24/7 for the two weeks before final examinations, including weekends.",
  general:
    "e.g. UNILinkd is our institute's unified digital platform for academics, attendance, placements, and campus life. " +
    "Students and faculty can reset their portal password from the login screen by selecting \"Forgot Password\" and following the emailed link.",
};
